// ─── BARRE de recherche commune : 🔽 filtre · champ · ↕ tri ───────
// Généralisée le 15/08 (Cédric) : cinq écrans dupliquaient ce bloc — même
// disposition, mêmes styles, copiés. Un seul modèle désormais.
//
// Les deux boutons sont OPTIONNELS : sans `onFiltres` (resp. `onTri`), le
// bouton n'est pas rendu — l'écran racine des budgets n'a que le champ.
// `nbFiltres` > 0 pose la pastille ; `triActif` allume le bouton de tri.
import React, { useMemo } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI, useT } from '@mop/core';

const HIT = { top: 8, bottom: 8, left: 8, right: 8 };

export default function BarreRecherche({
  valeur, onChange, placeholder, nbFiltres = 0, onFiltres, triActif = false, onTri,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  return (
    <View style={s.controles}>
      {!!onFiltres && (
        <TouchableOpacity style={[s.btnIc, nbFiltres > 0 && s.btnIcOn]} activeOpacity={0.7}
          onPress={onFiltres} accessibilityLabel={t('finances.filtrer')}>
          <Text style={s.ic}>🔽</Text>
          {nbFiltres > 0 && (
            <View style={s.pastille}><Text style={s.pastilleTxt}>{nbFiltres}</Text></View>
          )}
        </TouchableOpacity>
      )}

      <View style={s.rechercheZone}>
        <TextInput style={s.recherche} value={valeur} onChangeText={onChange}
          placeholder={placeholder ?? t('finances.rechercherPh')} placeholderTextColor={UI.faint} />
        {!!valeur && (
          <TouchableOpacity onPress={() => onChange?.('')} hitSlop={HIT}>
            <Text style={{ color: UI.muted, fontSize: 15 }}>✕</Text>
          </TouchableOpacity>
        )}
      </View>

      {!!onTri && (
        <TouchableOpacity style={[s.btnIc, triActif && s.btnIcOn]} activeOpacity={0.7}
          onPress={onTri} accessibilityLabel={t('finances.tri')}>
          <Text style={s.ic}>↕</Text>
        </TouchableOpacity>
      )}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  controles: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 8 },
  btnIc: { width: 42, height: 42, borderRadius: 11, alignItems: 'center', justifyContent: 'center', borderWidth: 0.5, borderColor: UI.border, backgroundColor: UI.card },
  btnIcOn: { borderColor: UI.accent, borderWidth: 1.5 },
  ic: { fontSize: 17 },
  pastille: { position: 'absolute', top: -4, right: -4, minWidth: 17, height: 17, borderRadius: 999, paddingHorizontal: 4, backgroundColor: UI.accent, alignItems: 'center', justifyContent: 'center' },
  pastilleTxt: { fontSize: 10.5, color: '#fff', fontWeight: '800' },
  rechercheZone: { flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: UI.card, borderRadius: 11, borderWidth: 0.5, borderColor: UI.border, paddingHorizontal: 12 },
  recherche: { flex: 1, paddingVertical: 10, fontSize: 14, color: UI.ink },
});
